import { healthApi, productApi } from "@api";
import { ComponentBread, ComponentHeader, StyledCreateLg } from "@components";
import { PATH_DEPO_RECORDS, PATH_PRODUCT_CREATE, PATH_PRODUCT_MASTER } from "@configs";
import { IProduct } from "@interfaces";

import { setLoading } from "@redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { ProductForm } from "@modules";

export const PageCreateProduct = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [product, setProduct] = useState<IProduct>();
  useEffect(() => {
    if (id) {
      fetchProduct();
    }
  }, [id]);
  const data = [
    {
      title: <a href={PATH_PRODUCT_MASTER || ""}>{t("page.product_master")}</a>,
    },
    {
      title: <a href={PATH_PRODUCT_CREATE || ""}>{t("page.add_new_product")}</a>,
    },
  ];
  const fetchProduct = async () => {
    try {
      dispatch(setLoading(true));
      const res = await productApi.detail(id);
      setProduct(res.data);
    } catch (err: any) {
      history.push(PATH_DEPO_RECORDS);
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <ComponentHeader title={t("page.add_new_product")} />
      <StyledCreateLg>
        <ComponentBread pages={data} />
        <ProductForm product={product} />
      </StyledCreateLg>
    </>
  );
};
